import React from 'react';

const experienceCards = [
  {
    id: 1,
    title: 'Analytics & Performance Tracking',
    text: 'You can gain complete visibility into your customer journey with our integrated analytics dashboard that reveals exactly how visitors interact with your store. The analysis helps you identify bottlenecks and optimize high-performing pages.',
    isRed: true
  },
  {
    id: 2,
    title: 'Scalable Architecture',
    text: 'Build your business on a website that never holds you back. Get a flexible website that handles everything from your first sale to millions. We make sure that your store accommodates increased traffic, expanded product catalogs, and new market opportunities.',
    isRed: false
  },
  {
    id: 3,
    title: 'Multi-Channel Integration',
    text: 'Your brand can expand its reach beyond the website with connections to major marketplaces and social media platforms. The omnichannel approach increases your sales opportunities and maintains consistent branding.',
    isRed: true
  },
  {
    id: 4,
    title: 'Conversion Focused Implementation',
    text: 'We use proven behavioral psychology principles in every design, be it color schemes and copy placement or checkout flows that guide customers toward making a purchase. Our conversion optimization methods are based on consumer research, which present consistent and measurable results.',
    isRed: false
  },
  {
    id: 5,
    title: 'Security & Trust Building',
    text: 'You can protect your business and customers with bank-grade security protocols, SSL certificates, and PCI compliance that safeguard sensitive data and build the trust factor among the audience. We make sure that your customer feel safe and secured when visiting your business online.',
    isRed: true
  },
  {
    id: 6,
    title: 'Monitoring & Support',
    text: "Now you don't have to lose sales due to technical issues. Our e-commerce web development agency has a round-the-clock monitoring system that detects and resolves problems before they impact your customers. We make sure that your store operates perfectly with automatic backups, security updates, and performance optimization.",
    isRed: false
  }
];

function EcommerceQualityExperience() {
  return (
    <section className="ecom-quality-section">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-quality-header">
          <div className="ecom-quality-badge-row">
            <span className="ecom-quality-badge">User Experience & Stability</span>
            <div className="ecom-quality-badge-line"></div>
          </div>

          <h2 className="ecom-quality-title">
            E-commerce Web Development Services To Offer a <span className="text-red">Quality User Experience</span>
          </h2>

          <p className="ecom-quality-subtitle">
            Engineered for resilience, high conversion, and seamless multi-channel operations that deliver unparalleled customer satisfaction.
          </p>
        </div>

        {/* Checkerboard Cards Grid */}
        <div className="ecom-quality-grid">
          {experienceCards.map((card) => (
            <div 
              key={card.id} 
              className={`ecom-quality-card ${card.isRed ? 'card-red' : 'card-white'}`}
            >
              <h3 className="ecom-quality-card-title">{card.title}</h3>
              <p className="ecom-quality-card-text">{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EcommerceQualityExperience;
